const exAlunosFormController = () => {
  const form = document.getElementById('contact-form')

  if( form ) {
     const url = '/wp-json/contact-form-7/v1/contact-forms/7/feedback'
     
     const inputValue = (inputName, type, action) => {

        const input = document.querySelector(`[name=${inputName}]`)

        if( action === 'get') {
           if( type === 'checkbox' ) 
              return input.checked

           return input.value
        }

        if( action === 'clear')
           input.value = ''
     }

     const formInputsName = [
        'contact-name',
        'contact-email',
        'contact-telephone',
        'contact-whatsapp',
        'contact-subject',
        'contact-message',
     ]

     const setFormStatus = ( type ) => {
        const formEl = document.getElementById('form-status')

        const removePreviousStatus = () => {
           formEl.classList.remove('hidden')
           formEl.classList.remove('loading')
           formEl.classList.remove('success')
           formEl.classList.remove('error')
        }

        const setLoading = () => {
           formEl.innerText = 'Sua mensagem está sendo enviada...'
           removePreviousStatus()
           formEl.classList.add('loading')
        }

        const setSuccess = () => {
           formEl.innerText = 'Sua mensagem foi enviada com sucesso!'
           removePreviousStatus()
           formEl.classList.add('success')
        }

        const setError = () => {
           formEl.innerText = 'Houve um erro ao enviar sua mensagem, tente novamente mais tarde.'
           removePreviousStatus()
           formEl.classList.add('error')
        }

        switch(type) {
           case 'loading':
              return setLoading()
           case 'success':
              return setSuccess()
           case 'error':
              return setError()
        }
     }

     const clearInputs = () => {
        formInputsName.forEach( name => {
           inputValue(name, null, 'clear')
        })
     }

     const blankInputs = () => {
        let blankInputs = false
        
        formInputsName.forEach( name => {
           if( inputValue(name, 'input', 'get') === '' ) 
              blankInputs = true
        })

        return blankInputs
     }

     const formSubmit = ( event ) => {
       const termsCheckbox = document.querySelector('input[name="contact-accept-terms"]').checked

       if(!blankInputs() && termsCheckbox) {
         event.preventDefault()


          setFormStatus('loading')

           const formData = new FormData(form)
           const requestSettings = {
              method: 'post',
              body: {...formData },
           }

           fetch(url, requestSettings)
              .then( response => response)
              .then( response => console.log(response))
              .catch( () => setFormStatus('error'))
              .then( () => clearInputs())
              .finally( () => setFormStatus('success'))
        }
     }

     form.addEventListener('submit', formSubmit)
  }
}

exAlunosFormController()


// WEBPACK FOOTER //
// ./scripts/forms/contact.js